module.exports = __webpack_public_path__ + "static/media/bi.f94dbe05.webp";